module.exports = __webpack_public_path__ + "img/8005.ea628843.gif";